import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer 
      className="bg-navy text-white" 
      data-testid="site-footer"
      itemScope 
      itemType="https://schema.org/WPFooter"
      role="contentinfo"
    >
      <div className="container-custom py-16">
        <div className="grid gap-12 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-1" itemScope itemType="https://schema.org/Organization">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-10 w-10 rounded-xl bg-copper flex items-center justify-center text-white font-heading font-bold text-xl" aria-hidden="true">
                R
              </div>
              <span className="font-heading font-semibold text-lg" itemProp="name">BevRelay</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed" itemProp="description">
              Curated beverage suppliers and buyers connected through trusted introductions. The national beverage relationship network.
            </p>
            <meta itemProp="url" content="https://bevrelay.com" />
          </div>

          {/* Links */}
          <div>
            <h4 className="text-copper font-semibold mb-4">Navigation</h4>
            <div className="flex flex-col gap-3 text-sm text-white/70">
              <Link to="/suppliers" className="hover:text-white transition-colors" data-testid="footer-suppliers-link">
                For Suppliers
              </Link>
              <Link to="/buyers" className="hover:text-white transition-colors" data-testid="footer-buyers-link">
                For Buyers
              </Link>
              <Link to="/target-list" className="hover:text-white transition-colors" data-testid="footer-target-list-link">
                Target List
              </Link>
              <Link to="/distributor-reps" className="hover:text-white transition-colors" data-testid="footer-reps-link">
                Distributor Reps
              </Link>
              <Link to="/about" className="hover:text-white transition-colors" data-testid="footer-about-link">
                About
              </Link>
              <Link to="/request-access" className="hover:text-white transition-colors" data-testid="footer-request-link">
                Request Access
              </Link>
            </div>
          </div>

          {/* Markets */}
          <div>
            <h4 className="text-copper font-semibold mb-4">Launch Markets</h4>
            <div className="flex flex-col gap-2 text-sm text-white/70">
              <span>Hawaii</span>
              <span>Nevada</span>
              <span>Illinois</span>
              <span className="text-white/50 mt-2 text-xs">Expanding to CA, TX, FL & beyond</span>
            </div>
          </div>

          {/* Contact */}
          <div itemScope itemType="https://schema.org/ContactPoint">
            <h4 className="text-copper font-semibold mb-4">Contact</h4>
            <p className="text-sm text-white/70 leading-relaxed">
              Email: <a 
                href="mailto:hello@bevrelay.com" 
                className="text-white font-medium hover:text-copper transition-colors"
                itemProp="email"
              >
                hello@bevrelay.com
              </a>
            </p>
            <meta itemProp="contactType" content="customer service" />
            <p className="mt-4 text-xs text-white/50 leading-relaxed">
              BevRelay is a relationship and discovery network. It is not a distributor, retailer, or marketplace.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container-custom py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} BevRelay. All rights reserved.
          </p>
          <nav className="flex gap-6 text-xs text-white/50" aria-label="Legal">
            <Link to="/privacy" className="hover:text-white/70 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white/70 transition-colors">Terms of Service</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
